import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Table } from 'reactstrap';

export default function AlertDialog({dialogValue,dialogClose,claimData,validateData}) {
  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open alert dialog
      </Button> */}
      <Dialog
        open={dialogValue}
        onClose={dialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Would you like to update claim data?"}
        </DialogTitle>
        <DialogContent>
        <Table striped>
      <thead>
        <tr>
          <th>Claim Number</th>
          <th>Employee Id</th>
          <th>IRD Number</th>
        </tr>
      </thead>
      <tbody>
        {claimData.map((data,index)=>(
             <tr key={index}>
             <th scope="row">{data.claimNumber}</th>
             <td>{data.employerId}</td>
             <td>{data.irdNumber}</td>
           </tr>
        ))}       
      </tbody>
    </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={dialogClose}>Cancel</Button>
          <Button onClick={validateData} autoFocus>
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}